import styled from 'styled-components';
import { getAuthorDetail } from '../../../api/Auhtor';
import { getReportList } from '../../../api/Report';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {Link, useNavigate, useParams} from 'react-router-dom';
import PageContent from '../../../components/PageContent';
import ReportTable from '../../../components/ReportTable';
import {Spin, Tag} from 'antd';
import BG from '../../../assets/images/report-list-bg.png';
import defaultAvatar from '../../../assets/images/icons/user-avater.png';
import { getTeamDetail } from '../../../api/Team';

const AuthorInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 350px 1fr;
  min-height: calc(100vh - 250px);
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  //padding: 30px 50px;
  padding: 30px;
  background-color: #090909;
  margin-right: 24px;
  border-radius: 6px;
  @media screen and (max-width: 1024px) {
    margin-right: 0;
    margin-bottom: 20px;
  }
`;

const AuthorAvatar = styled.img`
  width: 177px;
  height: 177px;
  border-radius: 50%;
`;

const AuthorContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  margin-top: 20px;
`;

const AuthorName = styled.div`
  overflow:hidden;
  width:100%;
  font-size: 22px;
  font-weight: 700;
  line-height: 22px;
  margin: 0;
  color: #fff;
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  justify-content: space-between;
  > .ant-tag {
    margin-left: 10px;
    cursor: pointer;
    border-color: #00eec2;
    color: #00eec2;
  }
`;
const AuthorSignature = styled.div`
  width: 100%;
  text-align: left;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* min-height: 60px; */
  font-size: 12px;
  color: #8a949e;
  padding-bottom: 10px;
  box-sizing: border-box;
`;

const TotalScore = styled.div`
  font-weight: bold;
  padding-top: 10px;
  border-top: 1px solid #1f1f1f;
  width: 100%;
`

const TeamCreater = styled.div`
  width: 100%;
  text-align: left;
  /* font-weight: 600; */
  padding-top: 20px;
  p,
  a {
    font-size: 14px;
    color: #fff;
  }
`;

const NoTeamTip = styled.div`
  width: 100%;
  text-align: left;
  /* font-weight: 600; */
  padding-top: 20px;
  p,
  a {
    font-size: 14px;
    color: #fff;
  }
`;

const TableContainer = styled.div`
  padding: 21px 24px;
  background-color: #0e0e0e;
  border-radius: 6px;
  background-image: url(${BG});
  background-repeat: no-repeat;
`;

const AuthorDetail = () => {
  // 定义多语言hooks
  const { t } = useTranslation();
  // 定义变量
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [tableLoading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [TeamData, setTeamData] = useState({});
  const [teamLoading, setTeamLoading] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    total: 0,
    currentPage: 1,
    perSize: 10,
  });

  const navigate = useNavigate()

  // 获取 url id

  const { id } = useParams();

  // 数据初始化
  useEffect(() => {
    setLoading(true);
    fetchData();
    return function () {
      setLoading(false);
      setData({});
      setTableData([]);
      setPageOptions({
        total: 0,
        currentPage: 1,
        perSize: 10,
      });
    };
  }, []);

  useEffect(() => {
    if (data && data.name) {
      fetchTableData(data.name);
    }
    // if (data && data.team_id) {
    //   fetchTeamData(data.team_id);
    // }
  }, [data.id, data.team_id]);

  // 获取作者详情数据
  const fetchData = async () => {
    try {
      const { data } = await getAuthorDetail(id);
      setData(data);
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };

  // 获取报告数据
  const fetchTableData = async (username,page,pageSize) => {
    try {
      const { data } = await getReportList({ username,page,pageSize, ...pageOptions });
      setTableData(data.list);
      setPageOptions({
        ...pageOptions,
        total: data.total,
        currentPage: data.current_page,
        perSize: data.per_page,
      });
      setTableLoading(false);
    } catch (error) {}
  };

  // 获取团队数据
  // const fetchTeamData = async (team_id) => {
  //   setTeamLoading(true);
  //   try {
  //     const { code, data } = await getTeamDetail({ team_id });
  //     if (code === '10000') {
  //       setTeamData(data);
  //     }
  //   } catch (error) {
  //     // console.log(error);
  //   }
  //   setTeamLoading(false);
  // };

  // 处理分页
  // const handlePageChange = (page, pageSize) => {
  //   setPageOptions({
  //     ...pageOptions,
  //     currentPage: page,
  //     pageSize,
  //   });
  //   setLoading(true);
  //   getReportList({
  //     page,
  //     pageSize,
  //   })
  //     .then(({ data }) => {
  //       for (let i = 0; i < data.list.length; i++) {
  //         data.list[i].key = i;
  //       }
  //       setPageOptions({
  //         ...pageOptions,
  //         total: data.total,
  //         currentPage: data.current_page,
  //         perSize: data.per_page,
  //       });
  //       setTableData(data.list);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // };
  const handlePageChange = (page, pageSize) => {
    setPageOptions({
      ...pageOptions,
      currentPage: page,
      pageSize,
    });
    setTableLoading(true);
    fetchTableData(data.name,page, pageSize);
  };

  return (
    <PageContent>
      <Spin spinning={loading}>
        <AuthorInfoContainer>
          <AuthorInfo>
            <AuthorAvatar src={data.avatar ? data.avatar : defaultAvatar} />
            <AuthorContent>
              <AuthorName>
                { data.name ? data.name.length > 12 ? data.name.substring(0, 12) + '...' : data.name : '' }
                {
                  data.team?.title ? (
                      <Tag onClick={() => navigate(`/whitehat-teams/${data.team.title}`)}>{data.team.title}</Tag>
                  ) : null
                }
              </AuthorName>
              {
                data?.hacker?.signature ? (
                    <AuthorSignature>{data?.hacker?.signature}</AuthorSignature>
                ) : null
              }
              <TotalScore>
                Total Score : {data?.hacker?.total_points.toLocaleString(navigator.language)}
              </TotalScore>
              {/* <Spin spinning={teamLoading}>
                {data && data.team_id ? (
                  <TeamCreater>
                    <p
                      style={{
                        fontSize: '14px',
                        fontWeight: '600',
                      }}
                    >
                      {t('author_detail.Team')}
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        alitems: 'center',
                      }}
                    >
                      <Link
                        to={`/team/detail/${TeamData.id}`}
                        style={{
                          fontSize: '12px',
                          lineHeight: '16px',
                        }}
                      >
                        {TeamData.title}
                      </Link>
                    </div>
                  </TeamCreater>
                ) : (
                  <NoTeamTip>Not in any team</NoTeamTip>
                )}
              </Spin> */}
            </AuthorContent>
          </AuthorInfo>

          <TableContainer>
            <div
              style={{
                fontSize: 18,
                fontWeight: 600,
              }}
            >
              {t('author_detail.released') + ` (${data.reports_count})`}
            </div>
            <ReportTable
              data={tableData}
              loading={tableLoading}
              pagination={{
                showSizeChanger: false,
                showQuickJumper: false,
                total: pageOptions.total,
                current: pageOptions.currentPage,
                pageSize: pageOptions.perSize,
                onChange: (page, pageSize) => {
                  handlePageChange(page, pageSize);
                },
              }}
            />
          </TableContainer>
        </AuthorInfoContainer>
      </Spin>
    </PageContent>
  );
};

export default AuthorDetail;
